import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import CartListDynamic from '../components/CartListDynamic';
import BillingForm from '../components/billing-form/BillingForm';
import PurchaseSuccess from '../components/PurchaseSuccess';
import PurchaseError from '../components/PurchaseError';
//import FacebookPixelPurchase from '../components/FacebookPixelPurchase';
//import GoogleTagManagerAction from '../components/GoogleTagManagerAction';

class PurchaseProductsView extends Component {

	render() {			
		const { shopStore } = this.props;
		const cart = shopStore.cart;
		const cashsale = shopStore.cashsale.get();
		const purchaseError = shopStore.purchaseError.get();
		if (purchaseError) {
			return <PurchaseError message={purchaseError} />
	  	} else if (cashsale) {			
			return ( 
				<span>
					<PurchaseSuccess
						orderNumber={cashsale.ordernumber} 
						total={cashsale.total} 
					/>
					{/*
					<FacebookPixelPurchase />
					<GoogleTagManagerAction action='purchase-success' />
					*/}
				</span>
			);
		}		
		return (
			<div className="container">				
				<div className="row">
					<div className="col-md-4 order-md-2 mb-4">
						<CartListDynamic />
					</div>
					{cart.get('hypoCashsale') &&
						<div className="col-md-8 order-md-1">
							<BillingForm />					
						</div>									
					}
				</div>
			</div>
		);
	}

}

export default inject('shopStore')(observer(PurchaseProductsView));




// WEBPACK FOOTER //
// ./src/views/PurchaseProductsView.js